import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../hooks/Loading";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { PhotoInsert, MediaGet } from "../../apis/api/GalleryApi";

const AddPhotoAlbum = ({ AddPhoto, onClose }) => {
  const dispatch = useDispatch();
  const [mediaArray, setMediaArray] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); 
  const { handleSubmit, register, reset, formState: { errors } } = useForm();

  const user_id = Cookies.get("userId");
  const company_id = Cookies.get("company_id");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setErrorMessage("");

    if (file) {
      if (file.type.match("image.*")) {
        setMediaArray([file]); 
      } else {
        setErrorMessage("Please select a valid image file (JPG, PNG, etc.)."); 
        setMediaArray([]); 
      }
    }
  };

  const handleRemoveMedia = () => {
    setMediaArray([]);
    setErrorMessage(""); 
  };

  const loading = useSelector((state) => state.gallerySlice.loading);
  const access_data = JSON.parse(Cookies.get("userJSON"));

  const onSubmitHandler = async (data) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("company_id", company_id);
    formData.append("uploade_photo", access_data.uploade_photo);
    formData.append("title", data.title);  // Append the title to the form data

    if (mediaArray.length > 0) {
      formData.append("Files", mediaArray[0]);
    }

    const response = await dispatch(PhotoInsert(formData));
    if (response?.payload?.status === "success") {
      reset();
      setMediaArray([]);
      onClose();
      await dispatch(MediaGet({ company_id: company_id, user_id: user_id }));
      toast.success("Photo album uploaded successfully!");
    } else {
      toast.error(response?.payload?.msz);
    }
  };

  const closeModel = () => {
    reset();
    setMediaArray([]);
    setErrorMessage(""); 
    onClose();
  };

  return (
    <>
      {AddPhoto && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "100vh",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Photo</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModel}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <Loading loading={loading} />
                  <form
                    method="post"
                    onSubmit={handleSubmit(onSubmitHandler)}
                    encType="multipart/form-data"
                  >
                    {/* Title Field */}
                    <div className="mb-3">
                      <label htmlFor="title" className="form-label">Title</label>
                      <input
                        id="title"
                        placeholder="Add photo tittle"
                        type="text"
                        className={`form-control ${errors.title ? "is-invalid" : ""}`}
                        {...register("title", { required: "Title is required" })}
                      />
                      {errors.title && (
                        <div className="text-danger">
                          {errors.title.message}
                        </div>
                      )}
                    </div>

                    {/* File Upload Section */}
                    <div className="upload__box mt-3">
                      <div className="upload__btn-box">
                        <label className="upload__btn">
                          <FontAwesomeIcon
                            icon={faUpload}
                            className="upload__icon"
                          />
                          <p>Choose a Photo</p>
                          <input
                            type="file"
                            className="upload__inputfile"
                            onChange={handleFileChange}
                          />
                        </label>
                      </div>

                      {errorMessage && (
                        <div className="alert alert-danger mt-2">
                          {errorMessage}
                        </div>
                      )}

                      <div className="upload__img-wrap d-flex flex-wrap mt-3">
                        {mediaArray.length > 0 && (
                          <div
                            className="upload__img-box me-2 mb-2"
                            style={{ width: "30%" }}
                          >
                            <div
                              className="position-relative"
                              style={{
                                width: "100%",
                                height: "100px",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                            >
                              <div
                                className="img-bg"
                                style={{
                                  backgroundImage: `url(${URL.createObjectURL(
                                    mediaArray[0]
                                  )})`,
                                  width: "100%",
                                  height: "100px",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              />
                              <button
                                className="upload__img-close btn btn-danger btn-sm position-absolute top-0 end-0"
                                onClick={handleRemoveMedia}
                              >
                                &times;
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary">
                        Upload Photo
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddPhotoAlbum;
